<template>
    <div class="rule">
        <div class="pages">
			<div class="prev" @click="handlePrevClick"><i class="iconfont icon-shangyiye"></i></div>
			<h2 class="title">第 {{number}} 章</h2>
			<div class="next" @click="handleNextClick"><i class="iconfont icon-gengduo"></i></div>
		</div>
		<div class="article" v-if="number == 1">
			<h1 class="title">总则</h1>
			<p class="text">
				第一条 本会的名称：济南市历下区文化产业协会。<br>
				第二条 本会的性质：济南市历下区文化产业协会是由历下区文化产业行业单位或个人自愿结成的非营利性社会组织。<br>
				第三条 本会的宗旨：拥护中国共产党的领导，拥护社会主义，遵守中华人民共和国宪法、法律、法规和国家政策；践行社会主义核心价值观，遵守社会道德风尚，发扬爱国、敬业、守法的传统；加强历下区文化产业之间的相互联系与交流，提高自身素质，提倡自尊、自信、自立、自强的精神，维护文化产业企业的合法权益，为会员搭建与各方沟通的桥梁，促进会员企业的健康发展，为改革开放和中国特色社会主义经济建设服务。<br>
				第四条 本会根据中国共产党章程的规定，设立中国共产党的组织，开展党的活动，为党组织的活动提供必要条件，承担保证政治方向、团结凝聚群众、推动事业发展、建设先进文化、服务人才成长、加强自身建设等职责。<br>
				第五条 本会接受济南市历下区民政局的业务指导和监督管理。<br>
				第六条 本会住所设在济南市经十路济南奥体中心体育场东奥艺术空间。
			</p>
		</div>
		<div class="article" v-if="number == 2">
			<h1 class="title">业务范围</h1>
			<p class="text">
				第七条 本会的业务范围：<br>
				(一)研究探讨文化产业发展的理论、向政府主管部门提出行业发展的政策建议；<br>
				(二)在政府部门的领导下，联合、组织会员，实施重大文化产业项目，加强优秀文化产品供应，以切实的举措推动文化产业发展；<br>
				(三)建立合理机制，解决会员在市场渠道、投融资、人才等方面的瓶颈，支持一批优秀的会员做大做强，培育一批优秀的文化企业家；<br>
				(四)积极推动、鼓励会员之间的合作，鼓励多种所有制文化企业深入合作，培育更加完善的文化产业链；<br>
				(五)积极总结、宣传、推广协会会员的成功经验，搭建网络平台，帮助会员推广产品和服务；<br>
				(六)开展文化产业基本情况调查，协助政府主管部门制定和实施行业发展规划和有关法规，开展行业自律，提高全行业的整体素质和经济效益、社会效益；<br>
				(七)维护会员单位的合法权益，为会员提供咨询、策划等服务；<br>
				(八)积极推广与展示先进的文化科技，开展文化艺术、技术与管理人才的培训，不断提高会员单位的企业素质；<br>
				(九)发展与外界的友好往来，组织企业间文化、技术、管理等方面的经验交流，推动横向经济合作与技术进步，与国外相关团体、机构建立友好往来关系，推动中国文化产业“走出去”;<br>
				(十)依照有关规定收集、编辑、出版行业有关政策法规、市场信息、刊物和资料；<br>
				(十一)承办政府有关部门和会员委托办理的事项；<br>
				(十二)根据行业发展需要，开展有利于本会的其它活动和公益事业。
			</p>
		</div>
		<div class="article" v-if="number == 3">
			<h1 class="title">会员</h1>
			<p class="text">
				第八条 本会会员种类<br>
				依法成立的文化产业和文化创意及相关产业企事业单位、研究机构、社会团体等，可以<br>
				单位会员身份申请加入本会。<br>
				从事文化产业工作的专家、学者、管理工作者及热心文化产业工作的人士，可以个人身份申请加入本会。<br>
				第九条 申请加入本会理事，必须具备下列条件：<br>
				（一）拥护本会的章程；<br>
				（二）有加入本会的意愿；<br>
				（三）在文化产业、专业领域或本会的业务领域内有一定的影响力；<br>
				（四）遵纪守法，截至申请之日止三年内没有违反法律、法规和规章的记录。<br>
				 第十条 会员入会的程序是：<br>
				（一）书面或网上填写文化产业协会入会申请表；<br>
				（二）经理事会讨论通过；<br>
				（三）呈交营业执照、学历、职称等证明文件；<br>
				（四）由理事会或理事会授权的机构发给会员证。<br>
				第十一条 会员享有下列权利：<br>
				（一）本团体的选举权、被选举权和表决权；<br>
				（二）参加本团体的活动；<br>
				（三）获得本团体服务的优先权；<br>
				（四）对本团体工作的批评建议权和监督权；<br>
				（五）入会自愿、退会自由；<br>
				第十二条 会员履行下列义务：<br>
				（一）执行本会的决议；<br>
				（二）维护本会合法权益；<br>
				（三）关心和支持协会工作，积极参加本会组织的各项活动，承办和完成本会交办的工作；<br>
				（四）按规定交纳会费；<br>
				（五）向本会反映情况，提供有关资料；<br>
				第十三条 会员退会应书面通知本会，并交回会员证。<br>
				会员如果1年不交纳会费或不参加本会活动的，视为自动退会。<br>
				第十四条 会员如有严重违反本章程的行为，经理事会或常务理事会表决通过，予以除名。
			</p>
		</div>
		<div class="article" v-if="number == 4">
			<h1 class="title">组织机构和负责人的产生、罢免</h1>
			<p class="text">
				第十五条 本会的最高权力机构是会员大会，会员大会的职权是：<br>
				（一）制定和修改章程；<br>
				（二）选举和罢免理事；<br>
				（三）审议理事会的工作报告和财务报告；<br>
				（四）审议监事（或监事会）的工作报告；<br>
				（五）决定终止事宜；<br>
				 (六) 制定和修改会费标准；<br>
				（七）决定其他重大事宜；<br>
				第十六条 会员大会须有2/3以上的会员出席方能召开，其决议须到会会员半数以上表
				决通过方能生效。<br>
				第十七条 会员大会每届五年。因特殊情况需提前或延期举办的，须由理事会表决通过，
				报历下区民政局批准同意。但延期换届最长不超过一年。<br>
				第十八条 理事会是会员大会的执行机构，在闭会期间领导本团体开展日常工作，对会员大会负责。<br>
				第十九条 理事的权利:<br>
				（一）理事会的选举权、被选举权和表决权；<br>
				（二）对本会工作情况、财务情况、重大事项的知情权、建议权和监督权；<br>
				（三）参与制定内部管理制度，提出意见建议；<br>
				（四）向理事长或理事会提出召开临时会议的建议权。<br>
				第二十条 理事应当遵守法律、法规和本章程的规定，忠实履行职责、维护本会利益，并履行以下义务：<br>
				（一）出席理事会会议，执行理事会决议；<br>
				（二）在职责范围内行使权利，不越权；<br>
				（三）不利用理事职权谋取不正当利益；<br>
				（四）不从事损害本会合法利益的活动；<br>
				（五）不得泄露在任职期间所获得的涉及本会的保密信息，但法律、法规另有规定的除外；<br>
				（六） 谨慎、认真、勤勉、独立行使被合法赋予的职权；<br>
				（七）接受监事对其履行职责的合法监督和合理建议；<br>
				第二十一条 理事会的职权是：<br>
				（一）执行会员大会的决议；<br>
				（二）选举和罢免理事长（会长）、副理事长（副会长）、秘书长；<br>
				（三) 筹备召开会员大会（或会员代表大会）;<br>
				（四）向会员大会报告工作和财务状况；<br>
				（五）决定会员的吸收或除名；<br>
				（六）决定设立办事机构、分支机构、代表机构和实体机构；<br>
				（七）决定副秘书长、各机构主要负责人的聘任；<br>
				（八）领导本团体各机构开展工作；<br>
				（九）制定内部管理制度；<br>
				 (十) 决定其他重大事项。<br>
				第二十二条 理事会须有2/3以上理事出席方能召开，其决议须经到会理事2/3以上表决通过方能生效。<br>
				第二十三条 理事会每年至少召开一次会议；情况特殊的，也可采用通讯形式召开。涉及改选换届、人、财、物等重大事项决议的理事会会议，不得以通讯方式召开。<br>
				第二十四条 本会设立常务理事会。常务理事会由理事会选举产生，在理事会闭会期间行使第十八条第一、三、五、六、七、八、九项的职权，对理事会负责。<br>
				第二十五条 常务理事会须有2/3以上常务理事出席方能召开，其决议须经到会常务理事2/3以上表决通过方能生效。<br>
				第二十六条 常务理事会至少半年召开一次会议；情况特殊的也可采用通讯形式召开。<br>
				第二十七条 本团体的理事长（会长）、副理事长（副会长）、秘书长必须具备下列条件：<br>
				（一）坚持党的路线、方针、政策，政治素质好；<br>
				（二）在本团体业务领域内有较大影响；<br>
				（三）理事长(会长)、副理事长(副会长)、秘书长最高任职年龄不超过70周岁，秘书长为专职；<br>
				（四）身体健康，能坚持正常工作；<br>
				（五）未受过剥夺政治权利的刑事处罚的；<br>
				（六）具有完全民事行为能力；<br>
				第二十八条 本会理事长（会长）、副理事长（副会长）、秘书长如超过最高任职年龄的，须经理事会表决通过，报历下区民政局批准同意后，方可任职。<br>
				第二十九条 本会理事长(会长)、副理事长(副会长)、秘书长任期5年，任期最长不得超过两届。因特殊情况需延长任期的，须经会员大会（或会员代表大会）2/3以上会员（或会员代表）表决通过，报历下区民政局批准同意后方可任职。<br>
				第三十条 本会理事长(会长)为本团体法定代表人。如因特殊情况需由副理事长（副会长）或秘书长担任法定代表人，应报历下区民政局批准同意后，方可担任，并在章程中写明。<br>
				本会法定代表人不兼任其他团体的法定代表人。<br>
				第三十一条 担任本会法定代表人的执行机构负责人被罢免，或本会原任法定代表人不予配合办理法定代表人变更登记的，本会可根据会员（代表）大会同意变更的决议，报历下区民政局审核同意后，由新当选的法定代表人代为行使职权，向历下区民政局申请变更登记。<br>
				第三十二条 本会理事长（会长）行使下列职权：<br>
				（一）召集和主持理事会（或常务理事会）；<br>
				（二）检查会员大会（或会员代表大会）、理事会（或常务理事会）决议的落实情况；<br>
				（三）代表本团体签署有关重要文件；<br>
				第三十三条 本会秘书长行使下列职权：<br>
			  	（一）主持办事机构开展日常工作，组织实施年度工作计划；<br>
			  	（二）协调各分支机构、代表机构、实体机构开展工作；<br>
			  	（三）提名副秘书长人选，交理事会或常务理事会决定；<br>
				（四）处理其他日常事务。<br>
				第三十四条 监事由理事会提名，会员（代表）大会选举产生，监事设1名，监事任期与理事会任期相同，期满可以连任。理事和财务管理人员不得兼任监事。<br>
				第三十五条  监事行使下列职权：<br>
				（一）列席理事会、常务理事会会议，并对理事会、常务理事会决议事项提出质询或建议；<br>
				（二）对理事、常务理事执行社会团体职务的行为进行监督，对违反法律、行政法规和章程的负责人、理事、常务理事提出依程序罢免的建议；<br>
				（三）检查财务和会计资料，监督理事会履行会员（代表）大会的决议；<br>
				（四）对理事、常务理事、负责人、财务管理人员损害社会团体利益的行为，及时予以纠正；<br>
				（五）向历下区民政局以及税务、会计主管部门反映社会团体工作中存在的问题；<br>
				（六）决定其他应由监事会审议的事项。<br>
				第三十六条 监事应当遵守有关法律法规和本会章程，忠实、勤勉履行职责。<br>
				第三十七条 监事可以对本会开展活动情况进行调查；必要时，可以聘请会计师事务所等协助其工作。监事行使职权所必需的费用，由本会承担。<br>
			</p>
		</div>
		<div class="article" v-if="number == 5">
			<h1 class="title">分支机构、代表机构</h1>
			<p class="text">
				第三十八条 本会在本章程规定的宗旨和业务范围内，根据工作需要设立分支机构、代表机构。本会的分支机构、代表机构是本会的组成部分，不具有法人资格，不得另行制订章程，不得发放任何形式的登记证书，在本会授权的范围内开展活动、发展会员，法律责任由本会承担。<br>
				分支机构、代表机构开展活动，应当使用冠有本会名称的规范全称，并不得超出本会的业务范围。<br>
				第三十九条 本会不设立地域性分支机构，不在分支机构、代表机构下再设立分支机构、代表机构。<br>
				第四十条 本会的分支机构、代表机构名称必须规范，分支机构以“分会”、“专业委员会”、“工作委员会”字样结束，代表机构以“办事处”、“代表处”字样结束。<br>
				第四十一条 分支机构、代表机构的负责人，年龄不得超过70周岁，主要负责人连任不超过2届。<br>
				第四十二条 分支机构、代表机构的财务必须纳入本会法定账户统一管理。<br>
				第四十三条 本会在年度工作报告中将分支机构、代表机构的有关情况报送历下区民政局。同时，将有关信息及时向社会公开，自觉接受社会监督。
			</p>
		</div>
		<div class="article" v-if="number == 6">
			<h1 class="title">管理制度和矛盾解决机制</h1>
			<p class="text">
				第四十四条 本会与境外非政府组织在境内合作开展临时活动，在开展临时活动15日前向其所在地的公安机关进行备案。<br>
				第四十五条 本会建立健全各项内部管理制度，完善相关管理规程。建立《会员管理办法》、《会员代表选举办法》、《会费管理办法》、《会员（代表）大会选举规程》、等相关制度和文件。<br>
				第四十六条 本会建立健全证书、印章、档案、文件等内部管理制度，并将以上物品和资料妥善保管于本会办公住所，任何单位、个人不得非法侵占。管理人员调动工作或者离职时，必须与接管人员办清交接手续。<br>
				第四十七条 本会证书、印章遗失时，经理事会2/3以上理事表决通过，在公开发布的报刊上刊登遗失声明后，可以向历下区民政局申请重新制发或刻制。如被个人非法侵占，应通过法律途径要求返还。<br>
				第四十八条 本会建立民主协商和内部矛盾解决机制。如发生内部矛盾不能经过协商解决的，可以通过调解、诉讼等途径依法解决。
			</p>
		</div>
		<div class="article" v-if="number == 7">
			<h1 class="title">资产管理、使用原则</h1>
			<p class="text">
				第四十九条 本会经费来源:<br>
				（一）会费；<br>
				（二）捐赠；<br>
				（三）政府资助；<br>
				（四）在核准的业务范围内开展活动或服务的收入；<br>
				（五）利息；<br>
				（六）其他合法收入。<br>
				第五十条 本会按照国家有关规定根据本会实际情况收取会费。<br>
				第五十一条 本会经费必须用于本章程规定的业务范围和事业的发展，不得在会员中分配。<br>
				第五十二条 本会认真执行《民间非营利组织会计制度》，聘用专职（兼职）出纳、会计人员，建立严格的财务管理制度，保证会计资料合法、真实、准确、完整。<br>
				第五十三条 本会配备具有专业资格的会计人员。会计不得兼任出纳。会计人员必须进行会计核算，实行会计监督。会计人员调动工作或离职时，必须与接管人员办清交接手续。<br>
				第五十四条 本会的资产管理必须执行国家规定的财务管理制度，接受会员大会（或会员代表大会）和财政部门的监督。资产来源属于国家拨款或者社会捐赠、资助的，必须接受审计机关的监督，并将有关情况以适当方式向社会公布。<br>
				第五十五条 本会重大资产配置、处置须经过理事会（常务理事会）审议。<br>
				第五十六条 本会理事会（常务理事会）决议违反法律、法规或章程规定，致使本会遭受损失的，参与审议的理事（常务理事）应当承担责任。但经证明在表决时反对并记载于会议记录的，该理事（常务理事）可免除责任。<br>
				第五十七条 本会换届或更换法定代表人之前必须接受历下区民政局组织的财务审计。本会法定代表人在任期间，本会发生违反《社会团体登记管理条例》、《山东省实施〈社会团体登记管理条例〉办法》和本章程的行为，法定代表人应当承担相关责任。因本会法定代表人失职，导致本会发生违法行为或本会财产损失的，法定代表人应当承担个人责任<br>
				第五十八条 本会的全部资产及其增值为本会所有，任何单位、个人不得侵占、私分和挪用，也不得在会员中分配。<br>
				第五十九条 本会专职工作人员的工资和保险、福利待遇，参照国家和我省的有关规定执行。
			</p>
		</div>
		<div class="article" v-if="number == 8">
			<h1 class="title">信息公开与信用承诺</h1>
			<p class="text">
				第六十条 本会依据有关政策法规，履行信息公开义务，建立信息公开制度，及时向会员公开年度工作报告、第三方机构出具的报告、会费收支情况以及经理事会研究认为有必要公开的其他信息，及时向社会公开登记事项、章程、组织机构、接受捐赠、信用承诺、政府转移或委托事项、可提供服务事项及运行情况等信息。<br>
				本会建立新闻发言人制度，经理事会或常务理事会通过，指定1名负责人作为新闻发言人，就本组织的重要活动、重大事件或热点问题，通过定期或不定期举行新闻发布会、吹风会、接受采访等形式主动回应社会关切。新闻发布内容应由本会法定代表人审定，确保正确的舆论导向。<br>
				第六十一条 本会建立年度报告制度，年度报告内容及时向社会公开，接受公众监督。未按规定报送年度报告的,列入社会组织活动异常名录。<br>
				第六十二条 本会重点围绕服务内容、服务方式、服务对象和收费标准等建立信用承诺制度，并向社会公开信用承诺内容。
			</p>
		</div>
		<div class="article" v-if="number == 9">
			<h1 class="title">章程的修改程序</h1>
			<p class="text">
				第六十三条 对本章程的修改，须经理事会表决通过后报会员大会（或会员代表大会）审议。<br>
				第六十四条 本会修改的章程，须在会员大会（或会员代表大会）通过后15日内,经历下区民政局审查同意，并核准后生效。
			</p>
		</div>
		<div class="article" v-if="number == 10">
			<h1 class="title">终止程序及终止后的财产处理</h1>
			<p class="text">
				第六十五条 本会完成宗旨或自行解散或由于分立、合并等原因需要注销的，由理事会或常务理事会提出终止动议。<br>
				第六十六条 本会终止动议须经会员大会（或会员代表大会）表决通过,并报历下区民政局审查同意。<br>
				第六十七条 本会终止前，须在历下区民政局指导下成立清算组织，清理债权债务，处理善后事宜。清算期间，不开展清算以外的活动。<br>
				第六十八条 本会经历下区民政局办理注销登记手续后即为终止。<br>
				第六十九条 本会终止后的剩余财产，在历下区民政局的监督下,按照国家有关规定，用于发展与本团体宗旨相关的事业。
			</p>
		</div>
		<div class="article" v-if="number == 11">
			<h1 class="title">附则</h1>
			<p class="text">
				第七十条 本章程经2018年12月27日会员大会表决通过。<br>
				第七十一条 本章程的解释权属本协会理事会。<br>
				第七十二条 本章程自历下区民政局核准之日起生效。
			</p>
		</div>
    </div>
</template>

<script>
export default {
    name: 'Rule',
    data() {
        return {
            number: 1
        }
    },
    methods: {
		handlePrevClick(){
			if(this.number == 1){
				alert('已经是第一章了')
				return
			}
			this.number --
		},
		handleNextClick(){
			if(this.number == 11){
				alert('已经是最后一章了')
				return
			}
			this.number ++
		}
	},
}
</script>

<style scoped>
.rule{
    margin-top: .2rem;
    background: #fff;
    overflow: hidden;
    padding: .25rem;
}
.pages{
    display: flex;
    margin-top: .375rem;
    justify-content: space-between;
    align-items: center;
}
.pages .title{
    color: #BB140D;
}
.pages div{
    width: .625rem;
    height: .55rem;
    text-align: center;
    line-height: .55rem;
    background: #D82D35;
    box-sizing: border-box;
}
.pages div .iconfont{
    color: #fff;
}
.article .title{
    margin: .4rem 0 .3rem 0;
    font-weight: bold;
    color: #333;
    text-align: center;
}
.article .text{
    font-size: .24rem;
    line-height: .6rem;
    padding-bottom: 1rem;
}
</style>